document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  const modal = document.getElementById('modal-1');
  const cartIcon = document.querySelector('[aria-controls="cart-drawer"]');

  if (!cartDrawer || !modal || !cartIcon) {
    return;
  }

  // Attach listeners only to buttons inside the cart drawer that trigger modal-1
  const setupModalButtonListeners = () => {
    const buttons = cartDrawer.querySelectorAll('[data-micromodal-trigger="modal-1"]');

    buttons.forEach((button) => {
      if (!button.hasAttribute('data-modal-listener')) {
        button.setAttribute('data-modal-listener', 'true');

        button.addEventListener(
          'click',
          () => {
            if (cartDrawer.hide) {
              cartDrawer.hide();
            }
          },
          true // use capture to beat shadow DOM overlay
        );
      }
    });
  };

  setupModalButtonListeners();

  // If buttons may appear dynamically INSIDE the cartDrawer
  const cartObserver = new MutationObserver(() => {
    setupModalButtonListeners();
  });

  cartObserver.observe(cartDrawer, {
    childList: true,
    subtree: true
  });

  // Observe modal open/close to reopen cart drawer
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        const wasOpen = mutation.oldValue?.includes('is-open');
        const isNowOpen = modal.classList.contains('is-open');

        // Closed → reopen cart after small delay
        if (wasOpen && !isNowOpen) {
          setTimeout(() => {
            cartIcon.click();
          }, 100);
        }
      }
    });
  });

  observer.observe(modal, {
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['class']
  });
});
